import { render, staticRenderFns } from "./EntityStepper.vue?vue&type=template&id=87ca48f4&scoped=true&lang=pug"
import script from "./EntityStepper.vue?vue&type=script&lang=js"
export * from "./EntityStepper.vue?vue&type=script&lang=js"
import style0 from "./EntityStepper.vue?vue&type=style&index=0&id=87ca48f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87ca48f4",
  null
  
)

export default component.exports